// extracted by mini-css-extract-plugin
module.exports = {"button":"carousel_controller-module__button--1uJFH","right":"carousel_controller-module__right--1rAFI","left":"carousel_controller-module__left--1r-xf"};